export enum TypeRejectEnum {
    PEDIDO = "1",
    COTIZACION = "2",
    VENTA_DIRECTA = "3",
    NUEVO_CLIENTE = "4",
    CAMBIO_PRODUCTO = "5",
    DEVOLUCION_PRODUCTO = "6",
    DOCUMENTO_PAGO = "7",
    ENTREGA = "8",
    FACTURA = "9",
    SOLICITUD_CREDITO = "10"
}